import { useMutation, useQuery } from "@tanstack/react-query";
import {getForfeitureReport} from "../../service/query/auth";

export const useGetForfeitureReport = ({ payload, page }) => {
  const forfeitureReport= useQuery({
    queryKey: ['forfeiturereport', payload, page],
    queryFn: () => getForfeitureReport({ ...payload, page }),
    enabled: !!payload && !!page,
    keepPreviousData: true,
  },
);
  return {data:forfeitureReport?.data?.data,  ...forfeitureReport,}
};